import api from 'services/api'
import { getDefaultAddressPostCode } from 'services/api/parser/profile'
import {
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAILURE,
} from '../../constants'
import { WM_CONSUMER_ID } from '../../../../utility/constants'

const getProfileSuccess = response => ({
  type: GET_PROFILE_SUCCESS,
  response,
})

const getProfileFailure = response => ({
  type: GET_PROFILE_FAILURE,
  response,
})

const getSegementData = (profileId) => {
  const data = {
    url: `/api/v1/users/external/${profileId}/segments`,
    method: 'GET',
    cache: 'no-cache',
    dataType: 'json',
    ignoreError: true,
    headers: {
      Accept: 'application/json',
      'WM_CONSUMER.ID': WM_CONSUMER_ID,
    },
  }
  return data
}

const getSegment = async (profileId) => {
  const { url, method, headers } = getSegementData(profileId)
  const response = await fetch(
    url,
    {
      method,
      headers,
      credentials: 'same-origin',
      redirect: 'follow',
    },
  )
  if (response.status === 200) {
    const responseData = await response.json()
    return responseData.data
  }
  return {
    user_id: '',
    segment_ids: [],
  }
}

const getProfile = (param = { full: 'n' }) => async (dispatch) => {
  const response = await api.request('getProfile', {}, param);
  const isSegmentApiAvailable = true;
  if (response.blockScript) {
    const { redirectUrl } = response
    window.location.assign(redirectUrl)
  } else if (response.status === 'OK') {
    const { profileAttributes = [], addresses = [], profileId = '' } = response
    const segmentResponse = isSegmentApiAvailable ? await getSegment(profileId) : {}
    const { segment_ids=[] } = segmentResponse
    const isBabyClubMember = !!profileAttributes.length
      && profileAttributes.some(ele => ele.attributeName === 'btc')
    dispatch(getProfileSuccess({
      ...response,
      isBabyClubMember,
      postCode: getDefaultAddressPostCode(addresses),
      segment_ids,
    }))
  } else {
    dispatch(getProfileFailure({ ...response }))
  }
  return response
}
export default getProfile



// WEBPACK FOOTER //
// ./services/app-state/profile/actions/getProfile/index.js